import { Icon, Button } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { NavigateOptions, useLocation, useNavigate } from "react-router-dom";

type ButtonProps = {
  navigateTo?: string;
  hasOnClickSpan?: boolean;
  text?: string;
  onClick?: () => void;
  options?: NavigateOptions;
};

const BackButton = ({
  navigateTo,
  hasOnClickSpan,
  onClick,
  text,
  options,
}: ButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  /*
    NOTE: If user navigates to some page in MC from another web page,
    then they won't have history in MC. And if we navigate back, then they
    will be taken out from MC, which is not good. Thus, we want to fallback
    to something safe.
  */
  const defaultBackPath = "/";

  const goToPrevious = () => {
    if (navigateTo) {
      return navigate(navigateTo, options);
    }
    if (hasOnClickSpan) {
      return;
    }

    // https://github.com/remix-run/react-router/discussions/9788
    if (location.key === "default") {
      return navigate(defaultBackPath, options);
    }

    return navigate(-1);
  };

  return (
    <Button
      variant="back-button"
      onClick={onClick || goToPrevious}
      testId="back-button"
    >
      <Icon.ChevronLeft /> {text || t("BACK")}
    </Button>
  );
};

export default BackButton;
